import { createTheme } from "@mui/material/styles";
import {
    FormulaData,
    IExsistAppointment,
    INewAppointment,
} from "@/shared/interfaces/schedulePage";

import { ICreateUser } from "@/shared/interfaces/patientPage";

export const URLADRESS = process.env.REACT_APP_API_BASE_URL;
export const PhotoAdress = process.env.REACT_APP_API_BASE_URL + "/photos";

// export const URLADRESS: string = "https://ortodont-backend.vercel.app/api/";
// export const URLADRESS: string = "http://localhost:80/api/";
// export const PhotoAdress = "http://localhost:80/api/photos";

export const ROWS: number = 10;
export const COLUMNS: number = 16;
export const chairsNum = 6;

export const data: {
    formula: FormulaData;
    notes: string;
} = {
    formula: {
        "0-0": "",
        "0-1": "",
        "1-2": "",
        "2-3": "",
        "1-3": "55",
        "1-4": "54",
        "1-5": "53",
        "1-6": "52",
        "1-7": "51",
        "1-8": "61",
        "1-9": "62",
        "1-10": "63",
        "1-11": "64",
        "1-12": "65",
        "3-13": "",
        "4-0": "18",
        "4-1": "17",
        "4-2": "16",
        "4-3": "15",
        "4-4": "14",
        "4-5": "13",
        "4-6": "12",
        "4-7": "11",
        "4-8": "21",
        "4-9": "22",
        "4-10": "23",
        "4-11": "24",
        "4-12": "25",
        "4-13": "26",
        "4-14": "27",
        "4-15": "28",
        "5-0": "48",
        "5-1": "47",
        "5-2": "46",
        "5-3": "45",
        "5-4": "44",
        "5-5": "43",
        "5-6": "42",
        "5-7": "41",
        "5-8": "31",
        "5-9": "32",
        "5-10": "33",
        "5-11": "34",
        "5-12": "35",
        "5-13": "36",
        "5-14": "37",
        "5-15": "38",
        "6-1": "",
        "6-10": "",
        "6-13": "",
        "7-8": "",
        "7-12": "",
        "8-3": "85",
        "8-4": "84",
        "8-5": "83",
        "8-6": "82",
        "8-7": "81",
        "8-8": "71",
        "8-9": "72",
        "8-10": "73",
        "8-11": "74",
        "8-12": "75",
    },
    notes: "some notes",
};

export const navigationItems = [
    { id: "schedule", title: "Розклад" },
    { id: "appointments", title: "Візити" },
    { id: "patients", title: "Пацієнти" },
    { id: "users", title: "Користувачі" },
    { id: "services", title: "Послуги" },
    { id: "statistic", title: "Статистика" },
];

export const timeSlots = [
    { value: "09:00", label: "09:00" },
    { value: "09:30", label: "09:30" },
    { value: "10:00", label: "10:00" },
    { value: "10:30", label: "10:30" },
    { value: "11:00", label: "11:00" },
    { value: "11:30", label: "11:30" },
    { value: "12:00", label: "12:00" },
    { value: "12:30", label: "12:30" },
    { value: "13:00", label: "13:00" },
    { value: "13:30", label: "13:30" },
    { value: "14:00", label: "14:00" },
    { value: "14:30", label: "14:30" },
    { value: "15:00", label: "15:00" },
    { value: "15:30", label: "15:30" },
    { value: "16:00", label: "16:00" },
    { value: "16:30", label: "16:30" },
    { value: "17:00", label: "17:00" },
    { value: "17:30", label: "17:30" },
    { value: "18:00", label: "18:00" },
    { value: "18:30", label: "18:30" },
    { value: "19:00", label: "19:00" },
    { value: "19:30", label: "19:30" },
    { value: "20:00", label: "20:00" },
    { value: "20:30", label: "20:30" },
    { value: "21:00", label: "21:00" },
    { value: "21:30", label: "21:30" },
    { value: "22:00", label: "22:00" },
    { value: "22:30", label: "22:30" },
    { value: "23:00", label: "23:00" },
];
export const startTimeSlots = [
    { value: "09:00", label: "09:00" },
    { value: "09:30", label: "09:30" },
    { value: "10:00", label: "10:00" },
    { value: "10:30", label: "10:30" },
    { value: "11:00", label: "11:00" },
    { value: "11:30", label: "11:30" },
    { value: "12:00", label: "12:00" },
    { value: "12:30", label: "12:30" },
    { value: "13:00", label: "13:00" },
    { value: "13:30", label: "13:30" },
    { value: "14:00", label: "14:00" },
    { value: "14:30", label: "14:30" },
    { value: "15:00", label: "15:00" },
    { value: "15:30", label: "15:30" },
    { value: "16:00", label: "16:00" },
    { value: "16:30", label: "16:30" },
    { value: "17:00", label: "17:00" },
    { value: "17:30", label: "17:30" },
    { value: "18:00", label: "18:00" },
    { value: "18:30", label: "18:30" },
    { value: "19:00", label: "19:00" },
    { value: "19:30", label: "19:30" },
    { value: "20:00", label: "20:00" },
    { value: "20:30", label: "20:30" },
    { value: "21:00", label: "21:00" },
    { value: "21:30", label: "21:30" },
    { value: "22:00", label: "22:00" },
    { value: "22:30", label: "22:30" },
];

export const endTimeSlots = [
    { value: "09:30", label: "09:30" },
    { value: "10:00", label: "10:00" },
    { value: "10:30", label: "10:30" },
    { value: "11:00", label: "11:00" },
    { value: "11:30", label: "11:30" },
    { value: "12:00", label: "12:00" },
    { value: "12:30", label: "12:30" },
    { value: "13:00", label: "13:00" },
    { value: "13:30", label: "13:30" },
    { value: "14:00", label: "14:00" },
    { value: "14:30", label: "14:30" },
    { value: "15:00", label: "15:00" },
    { value: "15:30", label: "15:30" },
    { value: "16:00", label: "16:00" },
    { value: "16:30", label: "16:30" },
    { value: "17:00", label: "17:00" },
    { value: "17:30", label: "17:30" },
    { value: "18:00", label: "18:00" },
    { value: "18:30", label: "18:30" },
    { value: "19:00", label: "19:00" },
    { value: "19:30", label: "19:30" },
    { value: "20:00", label: "20:00" },
    { value: "20:30", label: "20:30" },
    { value: "21:00", label: "21:00" },
    { value: "21:30", label: "21:30" },
    { value: "22:00", label: "22:00" },
    { value: "22:30", label: "22:30" },
    { value: "23:00", label: "23:00" },
];
export const resetAppontmentData: INewAppointment = {
    patientId: "",
    patientName: "",
    doctorId: "",
    doctorName: "",
    date: "",
    chairNumber: 1,
    startTime: "09:00",
    endTime: "",
    duration: 0,
    services: [],
    notes: "",
    paymentHistory: [],
    isAppointmentComplete: false,
    hasVisited: false,
};

export const resetExisttAppointment: IExsistAppointment = {
    _id: "",
    patientId: {
        _id: "",
        name: "",
        primaryPhone: "",
    },
    doctorId: {
        _id: "",
        name: "",
    },
    date: "",
    chairNumber: 1,
    startTime: "09:00",
    endTime: "",
    duration: 0,
    services: [],
    notes: "",
    paymentHistory: [],
    isAppointmentComplete: false,
    hasVisited: false,
};

export const inputStyles = {
    root: {
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#BCC3CD",
            },
            "&.Mui-focused fieldset": {
                border: "2px solid #1367B5",
            },
            "&.Mui-error fieldset": {
                border: "2px solid #ad1313",
            },
            "&:hover fieldset": {
                borderColor: "#BCC3CD",
            },
            "&:hover.Mui-focused fieldset": {
                borderColor: "#1367B5",
            },
            "&:hover.Mui-error fieldset": {
                borderColor: "#ad1313",
                fontFamily: "'Nunito Sans', sans-serif",
            },
            "& input": {
                color: "#090B0E",
            },
        },
        "& .MuiFormLabel-root": {
            color: "#47586E",
            fontFamily: "'Nunito Sans', sans-serif",
            "&.Mui-error": {
                color: "#ad1313",
            },
        },
        "& .MuiInputBase-root": {
            borderRadius: "6px",
        },
        "& .MuiInputBase-input": {
            fontWeight: "400 !important",
            fontSize: "16px !important",
            lineHeight: "24px !important",
            fontFamily: "'Nunito Sans', sans-serif",
            color: "#47586E",
        },
        "& .MuiFormHelperText-root": {
            fontFamily: "'Nunito Sans', sans-serif",
        },
        "& .MuiFormHelperText-root.Mui-error": {
            fontFamily: "'Nunito Sans', sans-serif",
            color: "#ad1313",
        },
    },
};

export const inputSearchInHeader = {
    root: {
        "& .MuiInputBase-root": {
            height: "44px",
            width: "404px",
            marginRight: "16px",
        },
        "& .MuiInputBase-input": {
            paddingLeft: "48px",
            fontFamily: "'Nunito Sans', sans-serif",
        },
    },
};

export const modalStyles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "760px",
    height: "auto",
    bgcolor: "background.paper",
    borderRadius: "6px",
    boxShadow: 24,
    outline: "none",
    p: 4,
    border: "none",
};

export const themeSelector = createTheme({
    typography: {
        fontFamily: '"Nunito Sans", sans-serif',
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: "6px",
                },
                notchedOutline: {
                    borderRadius: "6px",
                },
            },
        },
    },
});

export const patientsSortOptions = [
    { id: "-createdAt", title: "Від нових до старих" },
    { id: "createdAt", title: "Від старих до нових" },
    { id: "name", title: "Від А до Я" },
    { id: "-name", title: "Від Я до А" },
];

export const emptyPatientOnj = {
    name: "",
    gender: "",
    primaryPhone: "",
    adress: "",
    email: "",
    dateOfBirth: "",
    secondaryPhones: [{ type: "", number: "", _id: "" }],
    appointments: [],
    dentalFormulas: [],
    _id: "",
    paymentHistory: [],
    patientPhotos: [],
    patientsBirthDay: "",
};

export const emptyDoctorObj: ICreateUser = {
    name: "",
    email: "",
    password: "",
    passwordConfirm: "",
    roleInClinic: "doctor",
};

export const categotiesInheader = [
    { id: "info", name: "Інформація" },
    { id: "appointments", name: "Записи на прийом" },
    { id: "tooth_formulas", name: "Зубні формули" },
    { id: "photos", name: "Фотографії" },
];

export const categotiesInStats = [
    { id: "deptors", name: "Заборгованість клієнтів" },
    // { id: "appointments", name: "Ще якийсь звіт" },
    // { id: "tooth_formulas", name: "Ще ще якийсь звіт" },
];

export const categotiesInheaderForUserPage = [
    { id: "info", name: "Інформація" },
    { id: "appointments", name: "Записи на прийом" },
];

export const categoriesInHeaderSelector = [
    { id: "all", name: "Всі категорії" },
    { id: "ortodontiya", name: "Ортодонтія" },
    { id: "dityacha-stomatologiya", name: "Дитяча стоматологія" },
    { id: "stomatologiya-dlya-doroslih", name: "Стоматологія для дорослих" },
    { id: "hirurgiya", name: "Хірургія" },
    { id: "ortopedichna-stomatologiya", name: "Ортопедична стоматологія" },
];

export const categoriesInCreateService = [
    { id: "ortodontiya", name: "Ортодонтія" },
    { id: "dityacha-stomatologiya", name: "Дитяча стоматологія" },
    { id: "stomatologiya-dlya-doroslih", name: "Стоматологія для дорослих" },
    { id: "hirurgiya", name: "Хірургія" },
    { id: "ortopedichna-stomatologiya", name: "Ортопедична стоматологія" },
];

export const selectorStyles = {
    height: 44,
    width: 248,
    "& .MuiFormControl-root": {
        height: "40px !important",
    },
    "& .MuiSelect-select": {
        fontFamily: "'Nunito Sans', sans-serif",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "20px",
    },
    "& .MuiOutlinedInput-root": {
        transition: "border 0.3s ease-in-out",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "1px solid #BCC3CD !important",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#BCC3CD",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "2px solid #1367B5 !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "2px solid #1367B5 !important",
    },
    "& .MuiOutlinedInput-root:not(.Mui-focused) .MuiOutlinedInput-notchedOutline":
        {
            border: "1px solid #BCC3CD !important",
        },
    "& .MuiInputLabel-root": {
        fontFamily: "'Nunito Sans', sans-serif !important",
    },
};

export const recetNewService = {
    title: "",
    price: "0",
    category: "ortodontiya",
    description: "0",
    code: 0,
};

export const recetExistService = {
    _id: "",
    title: "",
    slug: "",
    price: "0",
    category: "all",
    description: "",
    quantity: 0,
    code: 0,
};

export const discauntValues = [
    { id: "0", label: "Без знижки", value: 0 },
    { id: "5", label: "5 відсотків", value: 5 },
    { id: "10", label: "10 відсотків", value: 10 },
    { id: "20", label: "20 відсотків", value: 20 },
    { id: "30", label: "30 відсотків", value: 30 },
    { id: "50", label: "50 відсотків", value: 50 },
];

export const slides = [
    {
        src: "https://faktypro.com.ua/uploads/img/11-cikavih-faktiv-pro-gori.jpg",
    },
    {
        src: "https://vsviti.com.ua/wp-content/uploads/2016/02/1-3.jpg",
    },
    {
        src: "https://vsviti.com.ua/wp-content/uploads/2016/02/2-3.jpg",
    },
    {
        src: "https://vsviti.com.ua/wp-content/uploads/2016/02/3-1.jpg",
    },
    {
        src: "https://vsviti.com.ua/wp-content/uploads/2016/02/4-2.jpg",
    },
];

export const adminMessage = "Зверніться до адміністратора!";
export const visitMessage =
    "Візит завершений і сплачений. Візит не підлягає редагуванню!";
export const emptyDataMessage = "Дані про пацієнта або лікаря відсутні";

export const addingButtonStyles = {
    border: "1px solid #b6d0e8",
    color: "#115da3",
    backgroundColor: "#f6f9f9",
    textTransform: "none",
    ":hover": {
        backgroundColor: "#dce8f4",
    },
    mt: 1,
    width: "100%",
    fontFamily: "'Nunito Sans', sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    height: "44px",
};
